import { useSelector } from 'react-redux';
import NavigationBar from '../NavigationBar/NavigationBar';
import SubmissionError from '../SubmissionError/SubmissionError';
import useShouldShowNavigation from '../../Hooks/useShouldShowNavigation/useShouldShowNavigation';

const NavigationSection = () => {
  const { pagesWithLoaderComponent } = useSelector((store) => store.paging);
  const { currentPage } = useSelector((store) => store.navigation);
  const { isDynamicHeightEnabled } = useSelector(
    (store) => store.optionalFormConfig
  );
  const isLoaderPage = pagesWithLoaderComponent.includes(currentPage);

  const { shouldShowNavigation } = useShouldShowNavigation();

  if (!shouldShowNavigation) {
    if (isDynamicHeightEnabled && isLoaderPage) {
      const inputAreaParentContainer = document.querySelector(
        '#inputAreaParentContainer'
      );
      inputAreaParentContainer.parentNode.style.display = 'flex';
    }
    return null;
  }

  return (
    <>
      <SubmissionError />
      <NavigationBar />
    </>
  );
};

export default NavigationSection;
